import React, { useMemo, useState } from 'react';
import SuppliesTable from '../../../components/SuppliesTable/SuppliesTable';
import PageHeader from '../../../components/PageHeader/PageHeader';
import CategoriesTable from '../../../components/Category/CategoriesTable';
import StockReplenishmentsTable from './../../../components/Reposition/StockReplenishmentsTable';
import { Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { categoryOptions, permissionOptions } from '../../../utils/Enums';
import CustomTabPanel from './../../../components/Tab/CustomTabPanel';
import { useParams } from 'react-router-dom';
import BulkImportButton from '../../../components/BulkImport/BulkImportButton';
export default function Supplies() {

  const { t } = useTranslation();
  const { locationId } = useParams();
  const [tabValue, setTabValue] = useState(0);
  const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const hasPermission = (permissionId) => userPermissions.includes(permissionId);
  const showCategoryTab = ['CREATE_CATEGORY', 'UPDATE_CATEGORY', 'DELETE_CATEGORY'].some((permissionLabel) =>
    hasPermission(permissionOptions.find(p => p.label === permissionLabel).id)
  );

  const tabs = useMemo(() => [
    {
      label: t('supplies'),
      content: (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
            <PageHeader title={t('supplies')} subtitle={t('manage_supplies')} />
            <BulkImportButton type="supplies" label={t('supplies')} onSuccess={() => window.location.reload()} />
          </Box>
          <SuppliesTable locationId={locationId} isBranch={false}/>
        </>
      )
    },
    {
      label: t('replenishment'),
      content: (
        <>
          <PageHeader title={t('replenishment')} subtitle={t('replenishment_header')} />
          <StockReplenishmentsTable locationId={locationId} replenishmentCategory={1} />
        </>
      )
    },
    ...(showCategoryTab ? [{
      label: t('category_supply'),
      content: (
        <>
          <PageHeader title={t('category')} subtitle={t('category_header')} />
          <CategoriesTable categoryType={ categoryOptions.SUPPLIES } />
        </>
      )
    }] : [])
  ], [locationId, showCategoryTab, t]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChangeTab} aria-label="basic tabs example">
          {tabs.map((tab) => (
            <Tab key={tab.label} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <CustomTabPanel key={tab.label} value={tabValue} index={index}>
          {tab.content}
        </CustomTabPanel>
      ))}
    </div>
  );
}
